module.exports = __webpack_public_path__ + "assets/logo-white.d6f476f7.svg";